'use client';

import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import sleepAndRestGradients from './_components/data/sleepAndRestGradients';
import SleepAndRestBlog from './_components/SleepAndRestBlog';
import SleepAndRestBlurb from './_components/SleepAndRestBlurb';
import SleepAndRestFeatures from './_components/SleepAndRestFeatures';
import SleepAndRestHero from './_components/SleepAndRestHero';
import SleepAndRestIntegrations from './_components/SleepAndRestIntegrations';
import SleepAndRestTestimonials from './_components/SleepAndRestTestimonials';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <>
      <SleepAndRestHero />
      <RadialGradientBG gradients={sleepAndRestGradients} background={null}>
        <SleepAndRestFeatures />
        <SleepAndRestBlurb />
        <SleepAndRestTestimonials />
        <SleepAndRestIntegrations />
      </RadialGradientBG>
      <SleepAndRestBlog />
    </>
  );
};

export default Content;
